import { Component } from '@angular/core';
import { PageBase } from '../../base/page-base/page-base.component';

@Component({
    templateUrl: './privacy-policy.page.html',
    selector: 'privacy-policy',
    standalone: false,
})
export class PrivacyPolicyPage extends PageBase {}
